import.meta.glob([
    '../img/**',
    '../fonts/**',
])

import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm'

import masonry from 'alpinejs-masonry'
import scrollTo from 'alpinejs-scroll-to'
import focus from '@alpinejs/focus'
Alpine.plugin(masonry)
Alpine.plugin(scrollTo)
Alpine.plugin(focus)

import Glide from '@glidejs/glide'

document.addEventListener('alpine:init', () => {
    Alpine.store('cart', {
        open: false,

        show() {
            this.open = true
        },

        hide() {
            this.open = false
        }
    })

    Alpine.store('search', {
        open: false,

        show() {
            this.open = true
        },

        hide() {
            this.open = false
        }
    })

    Alpine.store('guild', {
        open: false,

        show() {
            this.open = true
        },

        hide() {
            this.open = false
        }
    })

    Alpine.store('newFormula', {
        open: false,

        show() {
            this.open = true
        },

        hide() {
            this.open = false
        }
    })

    Alpine.store('newEdition', {
        open: false,

        show() {
            this.open = true
        },

        hide() {
            this.open = false
        }
    })

    Alpine.store('scentIntensity', {
        open: false,

        show(intensity) {
            this.open = intensity
        },

        hide() {
            this.open = false
        }
    })

    Alpine.store('addToCart', {
        inview: true,
        started: false,

        inView() {
            this.inview = !this.started ? this.inview : true
        },

        outOfView() {
            this.inview = !this.started ? this.inview : false
        },

        start(el) {
            const box = el.getBoundingClientRect()

            this.started = true
            this.inview = box.top < window.innerHeight && box.bottom >= 0
        }
    })

    document.addEventListener("keydown", (e) => {
        if ((e.ctrlKey && e.key === "k") || (e.metaKey && e.key === "k")) {
            e.preventDefault()
            Alpine.store('search').show()
        }
    })
})

window.addEventListener('analytics-activity', event => {
    if (typeof TriplePixel === 'function') {
        if (event?.detail?.output?.event) {
            TriplePixel(event.detail.output.event, event.detail.output.params)
        }
    }
})

window.addEventListener('cart-submission-complete', event => {
    Alpine.store('cart').show()
})

if (typeof TriplePixel === 'function') {
    let tracked25 = false
    let tracked50 = false
    let tracked75 = false
    let tracked100 = false
    window.addEventListener('scroll', function () {
        let scrollPercentage = Math.round((window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100)

        if (scrollPercentage >= 25 && !tracked25) {
            TriplePixel('custom', 'scrollDepthReached', {
                pageUrl: window.location.href,
                scrollPercentage: 25
            })
            tracked25 = true
        }

        if (scrollPercentage >= 50 && !tracked50) {
            TriplePixel('custom', 'scrollDepthReached', {
                pageUrl: window.location.href,
                scrollPercentage: 50
            })
            tracked50 = true
        }

        if (scrollPercentage >= 75 && !tracked75) {
            TriplePixel('custom', 'scrollDepthReached', {
                pageUrl: window.location.href,
                scrollPercentage: 75
            })
            tracked75 = true
        }

        if (scrollPercentage >= 100 && !tracked100) {
            TriplePixel('custom', 'scrollDepthReached', {
                pageUrl: window.location.href,
                scrollPercentage: 100
            })
            tracked100 = true
        }
    })
}

// Livewire go
window.Livewire = Livewire
Livewire.start()

// Glide go
window.Glide = Glide
